import { Form, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function EmailForm({ form, onSubmit, instructors }) {
  const { loading } = useSelector((state) => state?.emails);
  const { t } = useTranslation();
  const { TextArea } = Input;
  return (
    <Form
      layout="vertical"
      name="email_form"
      id="email_form"
      form={form}
      onFinish={onSubmit}
      disabled={loading}
      style={{
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      <Form.Item
        label={t("emails.crud.form.label.instructor")}
        name="formerId"
        rules={[
          {
            required: true,
            message: t("emails.crud.form.error.label.required.instructor"),
          },
        ]}
      >
        <Select>
          {instructors?.map((instructor) => (
            <Select.Option key={instructor?._id} value={instructor?._id}>
              {instructor?.fullName}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="emailSubject"
        rules={[
          {
            required: true,
            message: t("emails.crud.form.error.label.required.emailSubject"),
          },
        ]}
      >
        <Input placeholder={t("emails.crud.form.label.emailSubject")} />
      </Form.Item>
      <Form.Item
        name="message"
        rules={[
          {
            required: true,
            message: t("emails.crud.form.error.label.required.message"),
          },
        ]}
      >
        <TextArea rows={4} placeholder={t("emails.crud.form.label.message")} />
      </Form.Item>
    </Form>
  );
}
